import { api } from "./api";

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const getParcelasPagas = async (contrato) => {
  const resposta = await api(`${ENDPOINT}/clients/parcelas/pagas/${contrato}`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  return await resposta.json();
};

const getNotaFiscal = async (contrato, pacienteContratoParcelasId) => {
  const resposta = await api(`${ENDPOINT}/clients/parcelas/notafiscal/${contrato}/${pacienteContratoParcelasId}`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  return resposta;
};

const getParcelasContrato = async (contrato) => {
  const resposta = await api(`${ENDPOINT}/clients/parcelas/historico/${contrato}`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  return await resposta.json();
};

export { getParcelasPagas, getNotaFiscal, getParcelasContrato };
